import { Stack, useTheme } from "@mui/material";
import React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { ListStateIconFresh } from "source/components/framework/List/ListStateIconFresh";
import { ListStateIconLocked } from "source/components/framework/List/ListStateIconLocked";
import { ListStateIconUnread } from "source/components/framework/List/ListStateIconUnread";
import { ListStateIconUnpublished } from "source/components/framework/List/ListStateIconUnpublished/listStateIconUnpublished";
import { IRiskListItem } from "ui/Scripts/source/models/risk/riskListItem";
import { RiskListStateChip } from "./RiskListStateChip";
import { ListStateIconApproved } from "source/components/framework/List/ListStateIconApproved";
import { EnumHelper, RiskType } from "ui/Scripts/source/models/enums";
import { residualRiskLevelThreshold } from "ui/Scripts/source/models/consts";
import { Base } from "ui/Scripts/source/framework/base";

interface IRiskListStateColProps {
    trashBin: boolean;
    item: IRiskListItem
}

export const RiskListStateCol = (props: IRiskListStateColProps) => {
    const theme = useTheme();
    const isRisk = props.item.riskType === RiskType.Risk;

    return (
        <Stack direction="row" useFlexGap flexWrap="nowrap" overflow="hidden" alignItems="center">
            <RiskListStateChip
                code={props.trashBin
                    ? Translations.InTrashBin
                    : (props.item.archiveUser
                        ? Translations.Archived
                        : (props.item.publishUser
                            ? Translations.Published
                            : Translations.Draft))}
                color={props.trashBin
                    ? theme.palette.stateLightGray.main //InTrashBin
                    : (props.item.archiveUser
                        ? theme.palette.stateGray.main //Archived
                        : (props.item.publishUser
                            ? theme.palette.stateGreen.main //Published
                            : theme.palette.stateGray.main //Draft
                        ))}
            />
            {props.item.canEdit && !!props.item.publishUser && props.item.publishUser.date < props.item.modifyUser.date &&
                <ListStateIconUnpublished tooltip={isRisk ? Translations.RiskIsModifiedAfterItWasPublished : Translations.OpportunityIsModifiedAfterItWasPublished} />
            }
            <ListStateIconUnread unread={!props.item.isRead} />
            <ListStateIconFresh date={props.item.modifyUser.date} />
            {props.item.hasAssesment && props.item.residualRisk >= residualRiskLevelThreshold && !Base.isNullOrUndefined(props.item.approval) &&
                <ListStateIconApproved
                    customColor={EnumHelper.getApprovalTypeColor(props.item.approval)}
                    tooltip={EnumHelper.getApprovalTypeText(props.item.approval)}
                />
            }
            {props.item.canEdit &&
                <ListStateIconLocked locked={props.item.locked} />
            }
        </Stack>
    );
};
